import axios from 'axios'
import { message } from 'antd'
import getUrlQuery from '@/utils/getUrlQuery'
// @ts-ignore
const { baseUrl = '' } = window.AppConfig

let sys = ''

let baseURL = new URL(sys, baseUrl)

const netfetch = axios.create({
    baseURL: baseURL.href,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
    },
})

// 添加请求拦截器
netfetch.interceptors.request.use(
    (config) => {
        // @ts-ignore
        config.headers = {
            ...config.headers,
            token: getUrlQuery('token') || localStorage.getItem('token'),
            tenantId: getUrlQuery('tenantId') || localStorage.getItem('tenantId'),
        }
        return config
    },
    (error) => {
        console.log('before', error)
        throw error
    },
)

// 添加响应拦截器
netfetch.interceptors.response.use(
    //@ts-ignore
    (response) => {
        if (response.data.success) {
            return { data: response.data.data || {}, success: response.data.success }
        }
        throw response.data.data || response.data.msg || '未知错误'
    },
    (error) => {
        // 如果是404错误，直接抛出异常
        if (error.response?.status === 404) {
            throw new Error('接口不存在')
        }
        // 其他错误返回错误对象
        const err = {
            success: false,
            code: error.response?.status || '9001',
            msg: error.response?.data?.msg || '网络错误,请重试',
            data: null,
        }
        message.error(err.msg)
        return err
    },
)

export default netfetch
